import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Register from "./pages/Register";
import Coaches from "./pages/Coaches";
import Contact from "./pages/Contact";
import Forms from "./pages/Forms";
import ComingSoon from "./pages/ComingSoon";
import CheerRegister from "./pages/CheerRegister";
import Calendar from "./pages/Calendar";
import Store from "./pages/Store";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forms" element={<Forms />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cheer" element={<CheerRegister />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/store" element={<Store />} />
            <Route path="/basketball" element={<ComingSoon />} />
            <Route path="/track-and-field" element={<ComingSoon />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#0A0A0A",
            border: "1px solid #2D5F3F",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
